import { Alert } from "@swot/base-components";
import { redactTechnicalText } from "@cmts/api/apiErrorNormalizer.js";
import type { ApiFieldError } from "../services/api.service.js";

function safeFieldLabel(field: string): string {
  const cleaned = redactTechnicalText(field || "field").replace(/[^a-zA-Z0-9_. -]/g, "").trim();
  return cleaned || "field";
}

function safeValidationMessage(message: string): string {
  return redactTechnicalText(message || "Validation failed for this field.");
}

export function CmtsValidationErrorPanel({ fieldErrors, title = "Validation errors" }: { readonly fieldErrors?: readonly ApiFieldError[] | undefined; readonly title?: string | undefined }) {
  const errors = fieldErrors ?? [];
  if (!errors.length) return null;
  return (
    <Alert title={title} tone="warning">
      <ul>
        {errors.map((error) => {
          const field = safeFieldLabel(error.field);
          const message = safeValidationMessage(error.message);
          return <li key={`${field}-${error.code ?? message}`}><strong>{field}</strong>: {message}</li>;
        })}
      </ul>
    </Alert>
  );
}
